export enum ElementDetailCreateRelationshipTranslationKey {
    PICKED_ELEMENT = "elementsDetail.relationship.create.pickedElement",
    PICKED_ELEMENT_IS_SOURCE = "elementsDetail.relationship.create.pickedElementIsSource",
    PICKED_ELEMENT_IS_TARGET = "elementsDetail.relationship.create.pickedElementIsTarget",
    FIND_ELEMENT = "elementsDetail.relationship.create.findElement",
    DIALOG_CREATE_RELATIONSHIP_DIRECTION_SUCCEEDED = "elementsDetail.relationship.create.relationshipDirection.succeeded",
    DIALOG_CREATE_RELATIONSHIP_DIRECTION_NOT_SUCCEEDED = "elementsDetail.relationship.create.relationshipDirection.notSucceeded",
}
